import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManagePSUComponent from '../../components/ManagePSUComponent/ManagePSUComponent'

const ManagePSUDevice = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManagePSUComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManagePSUDevice
